import { render, staticRenderFns } from "./houseCode.vue?vue&type=template&id=603fb68f&scoped=true&"
import script from "./houseCode.vue?vue&type=script&lang=js&"
export * from "./houseCode.vue?vue&type=script&lang=js&"
import style0 from "./houseCode.vue?vue&type=style&index=0&id=603fb68f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603fb68f",
  null
  
)

export default component.exports